import {io} from 'socket.io-client';
import {base_url} from '../config';

function getSocketOrigin() {
  const base = base_url || '';
  const stripped = base.replace(/\/api\/?$/i, '').replace(/\/$/, '');
  return stripped || 'http://localhost:4000';
}

let socketSingleton = null;

export function getProjectSocket() {
  if (!socketSingleton) {
    socketSingleton = io(getSocketOrigin(), {
      withCredentials: true,
      autoConnect: false,
      transports: ['websocket', 'polling'],
    });
  }
  return socketSingleton;
}
